import cx from 'classnames';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import useThemeBlock from '@/hooks/useThemeBlock';
import { ButtonAnchorProps } from '@/helpers/Button/typings';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * COMPONENT
 */
export const ButtonAnchor: FC<ButtonAnchorProps> & BlockConfigs = ({
	title = '',
	href = '',
	className,
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-button',
		'supt-buttonAnchor',
		getStyles(blockTheme),
		className
	);

	// const onLinkClick = (event) => {
	// 	const anchor = event.target.hash;

	// 	// bail early if link is not an anchor
	// 	if (!anchor || !anchor.length || anchor[0] !== '#') {
	// 		return;
	// 	}

	// 	// prevent native event and scroll to the anchor
	// 	event.preventDefault();
	// 	scrollToAnchor(anchor);
	// };

	// const scrollToAnchor = (anchor) => {
	// 	// vars
	// 	const targetElement = document.querySelector(anchor);

	// 	// bail early if target doesn't exist
	// 	if (!targetElement) {
	// 		return;
	// 	}

	// 	// scroll to target
	// 	window.scroll({
	// 		top: targetElement.offsetTop,
	// 		left: 0,
	// 		behavior: 'smooth',
	// 	});
	// 	window.history.pushState(null, null, `${anchor}`);
	// };

	return isEmpty(title) ? null : (
		<a
			className={rootClass}
			href={href}
			// onClick={onLinkClick} // Removed to use the native scroll to anchors, so we can use scroll-margin-top and scroll-padding-top
			data-block={block.slug}
			{...htmlProps}
		>
			<span className="supt-button__inner">
				<span>{title}</span>
			</span>
		</a>
	);
};

ButtonAnchor.slug = block.slug;
ButtonAnchor.title = block.title;
